module.exports = __webpack_public_path__ + "img/img6.0f5354ca.svg";